import { Component, OnInit, ViewContainerRef, ElementRef, Injector, ViewChild, TemplateRef, Input, AnimationCallbackEvent, WritableSignal, signal, ChangeDetectorRef } from '@angular/core';
import { Overlay, OverlayOutsideClickDispatcher, OverlayRef } from '@angular/cdk/overlay';
import { take } from 'rxjs/operators';
import { TranslateService, LangChangeEvent, TranslateModule } from '@ngx-translate/core';
import { PopupService } from '../../services/popup.service';
import { MarkerService } from '../../services/marker.service';
import { MapService } from '../../services/map.service';
import { BaseLayerSelectorComponent } from '../base-layer-selector/base-layer-selector.component';
import { LayerService } from '../../services/layers/layer.service';
import { Layer } from '../../models/layer';
import { OlLayerService } from '../../services/ol/ol-layer.service';
import { AnimationEvent, animate, state, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { PopoverService } from '../popover/popover.service';
import { LayerinfoPopoverComponent } from './layerinfo-popover/layerinfo-popover.component';
import { unByKey } from 'ol/Observable';
import { CommonModule } from '@angular/common';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { HeaderComponent } from '../header/header.component';
import { LanguageChooserComponent } from '../language-chooser/language-chooser.component';
import { MapComponent } from '../map/map.component';
import { FormsModule } from '@angular/forms';
import { PopoverComponent } from '../popover/popover/popover.component';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '@tt-lib/services/toggle-event.service';

@Component({
  selector: 'tt-base-layer-theme-selector',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatListModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatGridListModule,
    MatSnackBarModule,
    MatDialogModule,
    TranslateModule,
    MatTabsModule,
    CommonModule,
    FormsModule,
    // PopoverComponent
  ],
  templateUrl: './base-layer-theme-selector.component.html',
  styleUrls: ['./base-layer-theme-selector.component.scss'],
  // animations: [
  //   trigger('openClose', [
  //     state('open', style({
  //       opacity: 1.0,
  //       transform: 'scale(1.0)'
  //     })),
  //     state('close', style({
  //       opacity: 0.0,
  //       transform: 'scale(0.8)'
  //     })),
  //     transition('open => close', animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
  //     transition('close => open', animate('250ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
  //   ])
  // ],
  standalone: true
})

export class BaseLayerThemeSelectorComponent extends BaseLayerSelectorComponent implements OnInit {
  @Input() showAsIcon: boolean;
  @ViewChild('baselayerPanel') baselayerPanelTemplate: TemplateRef<unknown>;
  @ViewChild('baselayerSelectorButtonContainer') baselayerSelectorButtonContainer: Element;
  declare protected overlayRef: OverlayRef;
  declare protected isAnimating: boolean;
  protected subscriptions: Subscription = new Subscription();
  protected layerIds: string[];
  protected bodyEl: HTMLBodyElement;
  // selectedBaseSubLayerId: string;
  automaticLevels: boolean;

  themekeys: string[];
  tabindex: number;

  zoomChangeListener;
  sublayerId;

  autoActivatedLayerid: WritableSignal<String> = signal('');


  public themes: any = { 'cartoweb': [], 'classicmap': [], 'ortho': [] };
  // overlayOutsideClickDispatcher: any;

  constructor(
    public layerService: LayerService,
    public overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private popoverService: PopoverService,
    public _viewContainerRef: ViewContainerRef,
    protected _elementRef: ElementRef<HTMLElement>,
    injector: Injector,
    public popup: PopupService,
    public markerService: MarkerService,
    public mapService: MapService,
    public translateService: TranslateService,
    private olLayerService: OlLayerService,
    private backEventService: BackEventService,
    private toggleEventService: ToggleEventService,
    cdr: ChangeDetectorRef 
    // private permalinkService: PermalinkService,
    // overlayOutsideClickDispatcher: OverlayOutsideClickDispatcher

  ) {
    super(
      layerService,
      overlay,
      _viewContainerRef,
      _elementRef,
      injector,
      popup,
      markerService,
      mapService,
      cdr
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.layerService.getSelectedBaselayer$().pipe(take(1)).subscribe(() => {
      this.layerService.getBaseLayersList().subscribe((layers) => {
        //creating theme tree
        this.themekeys = Object.keys(this.themes);
        this.themekeys.forEach((theme, i) => {
          this.themes[theme] = layers.filter((layer: any) => layer.themes?.includes(theme));
        })
        this.setInitialSelectedThemeAndLayer(this.selectedBaselayer);
      });
      //setTimeout(() => this.toggle(), 500);
      this.layerIds = this.layerService.getBaseLayers().map((layer) => { return layer.id });
      this.bodyEl = document.getElementsByTagName("body")[0];
      this.setBodyCss(this.selectedBaselayer.id);
    });

    this.subscriptions.add(
          this.toggleEventService.emitter$.subscribe(
            (toggleEvent: ToggleEventType) => {
              if (toggleEvent.forwardedFor === 'base-layer-theme-selector' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
                if (this.isOpen()) {
                      this.close();
                    }
              }
            }
          )
        );
  }

  ngOnDestroy() {
    //!
    this.subscriptions.unsubscribe();
    if (this.overlayRef) { this.overlayRef.dispose(); }
    if (this.zoomChangeListener) {
      unByKey(this.zoomChangeListener);
      delete this.zoomChangeListener;
    }
  }

  showPopover(target: HTMLElement, layerId) {
    this.popoverService.open(
      LayerinfoPopoverComponent,
      target,
      {
        data: this.getLayerInfo(layerId),
        // backdropClass: '',
        // disableClose: false,
        panelClass: ['bottom', 'left'],
        panelOffset: 20,
        arrowSize: 20
      },
      this.viewContainerRef
    )
    // .afterClosed()
    // .subscribe(result => {
    //   console.log(`Closed with ${result}`);
    // });
  }


toggle() {
  if (this.isAnimating) return;
  this.isOpen() ? this.close() : this.open();
}

open() {
  if (!this.overlayRef) {
    this.overlayRef = this.createOverlay();
    this.overlayRef.outsidePointerEvents().subscribe(() => this.close());
  }

  const drawerPortal = new TemplatePortal(this.baselayerPanelTemplate, this._viewContainerRef);
  if (!this.overlayRef.hasAttached()) {
    this.overlayRef.attach(drawerPortal);
  }

  this.isOpen.set(true);
  this.onEnter();
}

close() {
  this.isOpen.set(false);
  this.isAnimating = true;
}

onEnter() {
  this.isAnimating = true;
}

onLeave() {
  this.isAnimating = false;
  if (this.overlayRef) {
    this.overlayRef.detach();
    this.overlayRef.detachBackdrop();
  }
}

handleAnimationDone(event: TransitionEvent) {
  // Filter for the property you are animating (e.g., opacity)
  if (event.propertyName !== 'opacity') return;

  if (!this.isOpen()) {
    // Only detach AFTER the CSS transition finishes
    this.onLeave();
  } else {
    this.isAnimating = false;

    this.backEventService.registerOpenedWindow({windowName: 'base-layer-theme-selector', isAutoCloseableWindow: false});
  }
}


  setInitialSelectedThemeAndLayer(selectedBaselayer: Layer) {
    this.layerService.setActiveBaselayerId$(selectedBaselayer.id);
    this.themekeys.forEach((theme, i) => {
      this.themes[theme].active = (this.themes[theme].some((lyr) => { return lyr.active = lyr.id.includes(selectedBaselayer.id) })) ? true : false;
      //set tabindex
      if (this.themes[theme].active) this.tabindex = i;
    })
    if (selectedBaselayer.id === "classic.maps") this.setAutomaticLevels(true)
  }

  switchTheme(tabChangeEvent) {
    let selectedTheme = this.themekeys[tabChangeEvent.index];
    this.themekeys.forEach((theme, i) => {
      this.themes[theme].active = (theme === selectedTheme) ? true : false;
    });
    let layer: Layer;
    if (selectedTheme === 'classicmap' && this.automaticLevels) {
      layer = this.themes['classicmap'][0]
    }
    else {
      //if no active layer was set already, take first one
      layer = this.themes[selectedTheme].find((layer) => layer.active) || this.themes[selectedTheme][0];
    }
    if (layer.id === 'classic.maps') {
      this.setAutomaticLevels(true);
    }
    else {
      //
      this.unSetZoomListener();
      this.switchBaseLayer(layer.id);
    }
  }

  setSelectedThemeAndLayer(layerId) {
    this.layerService.setActiveBaselayerId$(layerId);
    this.themekeys.forEach((theme) => {
      if (this.themes[theme].active) {
        //set selectedlayer active
        this.themes[theme].forEach(lyr => {
          lyr.active = (lyr.id === layerId) ? true : false;
          if (theme === 'classicmap' && this.automaticLevels && lyr.active) { 
            this.autoActivatedLayerid.set(lyr.id);
          } else if((theme !== 'classicmap' || !this.automaticLevels) &&  this.autoActivatedLayerid() !== '') {
            this.autoActivatedLayerid.set('');
          }
        });
      }
    });
    // add a css class to body, so css can change background color..
    this.setBodyCss(layerId);
  }

  private setBodyCss(layerId: string) {
    if (this.layerIds) {
      for (var i = 0; i < this.layerIds.length; i++) {
        this.bodyEl.classList.remove(this.layerIds[i]);
      }
      this.bodyEl.classList.add(layerId)
    }

  }

  setAutomaticLevels(val: boolean) {
    this.automaticLevels = val;
    if (this.automaticLevels) {
      let layer: Layer;
      this.layerService.findAvailableBusinessLayerById('classic.maps').subscribe((lyr) => layer = lyr);
      this.switchBaseLayer(layer.id);
      this.setSelectedThemeAndLayer(this.getVisibleLayerIdInTheme());
      this.setZoomListener();
    } else {
      //unlisten
      this.unSetZoomListener();
      let layerId = (this.selectedBaselayer.id === 'classic.maps') ? this.getVisibleLayerIdInTheme() : this.selectedBaselayer.id;
      this.switchBaseLayer(layerId);
    }
  }

  getVisibleLayerIdInTheme() {
    let layerId;
    //todo has troubles with 'dots' in indexof
    let classiclayer = this.olLayerService.getOlBaselayers().find(layer => layer.get('customId').indexOf('maps') > 0);
    classiclayer.getLayers().forEach((layer) => {
      if (this.isVisibleAtThisResolution(layer)) {
        layerId = layer.get('customId');
      }
    });
    //cut the '_g'
    return layerId.slice(0, -2);
  };

  isVisibleAtThisResolution(layer) {
    let v;
    if (this.map.getView().getResolution() >= layer.getMaxResolution()) {
      v = false;
    } else if (this.map.getView().getResolution() < layer.getMinResolution()) {
      v = false;
    } else {
      v = true;
    }
    return v;
  }

  setZoomListener() {
    if (!this.zoomChangeListener) {
      this.zoomChangeListener = this.map.on('movestart', (evt) => {
        let firstZoom = this.map.getView().getZoomForResolution(evt.frameState.viewState.resolution);
        this.map.once('moveend', (evt) => {
          let currentZoom = parseInt(this.map.getView().getZoom(), 10);
          if (currentZoom !== firstZoom) {
            //zoomlevel has changed, set sublayer  
            if (this.selectedBaselayer.id !== 'classic.maps') {
              this.switchBaseLayer('classic.maps');
            }
            this.setSelectedThemeAndLayer(this.getVisibleLayerIdInTheme());
          }
        });
      });
    }
  }

  unSetZoomListener() {
    unByKey(this.zoomChangeListener);
    delete this.zoomChangeListener;
  }

  switchBaseLayer(layerId) {
    this.setSelectedThemeAndLayer(layerId)
    super.switchBaseLayer(layerId);
  }

  getSublayerClass = function (layer: Layer) {
    let cssClass = this.getClassName(layer.id);
    if (!this.showAllSubLayers && (layer.id === this.selectedBaseSubLayerId)) {
      cssClass += ' selected';
    }
    return cssClass;
  };

  protected createOverlay(): OverlayRef {
    const positionStrategy = this.overlay.position().flexibleConnectedTo(this.baselayerSelectorButtonContainer)
      //.flexibleConnectedTo(this._elementRef)      
      .withPositions([{
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'top'
      }])
      .withFlexibleDimensions(true);
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      backdropClass: 'tt-backdrop-transparent',
      positionStrategy: positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });
    return this.overlayRef;
  }

  // onEnter(event: AnimationCallbackEvent) {
  //   this.isAnimating = true;
  // }

  // onLeave(event: AnimationCallbackEvent) {
  //   this.isAnimating = true;
  //   event.animationComplete();
  //   this.overlayRef.detach();
  //   this.isAnimating = false;
  // }
  //is this good practice?
  getThemeClass = function (name) {
    let cssClass = (this.themes[name].active) ? 'active ' + this.getClassName(name) : this.getClassName(name);
    //cssClass += (layer.id === this.selectedBaselayer.id) ? ' selected' : '';
    //console.log('cssClass', cssClass);    
    return cssClass;
  };
  //is this good practice?
  getClass = function (layer) {
    let cssClass = (layer.active) ? 'active ' + this.getClassName(layer.id) : this.getClassName(layer.id);
    return cssClass;
  };

  getLayerInfo(l) {
    let data =
    {
      layerInfoTxt: "layerinfo." + l + "_TXT",
      layerInfoUrl: (l === 'top10map') ? undefined : "layerinfo." + l + "_URL",
      layerInfoMetadataUrl: (l === 'ngi.cartoweb.topo.be') ? "layerinfo." + l + "_METADATA_URL" : (l === 'ngi.ortho') ? "layerinfo." + l + "_METADATA_URL" : (l === 'ngi.cartoweb.topo_bw.be') ? "layerinfo." + l + "_METADATA_URL" : undefined
    }
    return data;
  };

}